// Fade in layer before anything else
fadeInPage();

// highlight main header menu active link
const mainHeaderMenu = document.querySelector("[data-main-header-menu]");
if (mainHeaderMenu) {
  const currentLink = mainHeaderMenu.querySelector(
    `a[href$="${window.location.pathname}"]`
  );
  if (currentLink) {
    currentLink.classList.add('active')
  }
}

// highlight account header active link
const accountPageMenu = document.querySelector(".account-page__menu");
if (accountPageMenu) {
  const currentLink = accountPageMenu.querySelector(
    `a[href$="${window.location.pathname}"]`
  );
  if (currentLink) {
    currentLink.classList.add('active')
  }
}

function customerAddressForm() {
  var newAddressForm = document.getElementById('AddressNewForm');
  var newAddressFormButton = document.getElementById('AddressNewButton');

  if (!newAddressForm) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    // eslint-disable-next-line no-new
    new Shopify.CountryProvinceSelector(
      'AddressCountryNew',
      'AddressProvinceNew',
      {
        hideElement: 'AddressProvinceContainerNew'
      }
    );
  }

  // Initialize each edit form's country/province selector
  document
    .querySelectorAll('.address-country-option')
    .forEach(function(option) {
      var formId = option.dataset.formId;
      var countrySelector = 'AddressCountry_' + formId;
      var provinceSelector = 'AddressProvince_' + formId;
      var containerSelector = 'AddressProvinceContainer_' + formId;

      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
        hideElement: containerSelector
      });
    });

  // Toggle new/edit address forms

  document.querySelectorAll('.address-new-toggle').forEach(function(button) {
    console.log('Address',);
    button.addEventListener('click', function() {
      console.log('click');
      var isExpanded =
        newAddressFormButton.getAttribute('aria-expanded') === 'true';

      newAddressForm.classList.toggle('hidden');
      newAddressFormButton.setAttribute('aria-expanded', !isExpanded);
      newAddressFormButton.focus();
    });
  });

  document.querySelectorAll('.address-edit-toggle').forEach(function(button) {
    button.addEventListener('click', function(evt) {
      var formId = evt.target.dataset.formId;
      var editButton = document.getElementById('EditFormButton_' + formId);
      var editAddress = document.getElementById('EditAddress_' + formId);
      var isExpanded = editButton.getAttribute('aria-expanded') === 'true';

      editAddress.classList.toggle('hidden');
      editButton.setAttribute('aria-expanded', !isExpanded);
      editButton.focus();
    });
  });

  document.querySelectorAll('.address-delete').forEach(function(button) {
    button.addEventListener('click', function(evt) {
      var target = evt.target.dataset.target;
      var confirmMessage = evt.target.dataset.confirmMessage;

      // eslint-disable-next-line no-alert
      if (
        confirm(
          confirmMessage || 'Are you sure you wish to delete this address?'
        )
      ) {
        Shopify.postLink(target, {
          parameters: { _method: 'delete' }
        });
      }
    });
  });
}


if (window.location.pathname.includes('/account')) {
  customerAddressForm();
}


// Helper function used in other js files (i.e. horizontal-scroll.js), so using 'function' so we can declare it multiple times with the same exact name
function getRandomSize(min, max) {
  return Math.round(Math.random() * (max - min) + min);
}
//Start and load cart for more info see https://github.com/bornfight/goCart.js
window.addEventListener("load", function () {
  // Add white background to header on hover
  const header = document.querySelector("[data-site-header]");
  const headerMenuTriggers = document.querySelectorAll("[data-main-header-menu-trigger]");
  // headerMenuTriggers.forEach(trigger => trigger.addEventListener("mouseenter", () => header.classList.add("bg-white", "dark:bg-lightGrey")))
  // headerMenuTriggers.forEach(trigger => trigger.addEventListener("mouseleave", () => header.classList.remove("bg-white", "dark:bg-lightGrey")))

  // hide menu on scroll
  const toggleMenu = () => {
    const mainMenu = document.querySelector("[data-main-header-menu-wrapper]");
    var currentScrollPos = window.pageYOffset;
    const scrollThreshold = window.innerWidth < 1024 ? 36 : 60;
    const searchPageHader = document.querySelector(".search-page__header");
    const searchScrollThreshold = window.innerWidth < 1024 ? 116 : 80;

    if (mainMenu) {
      if (currentScrollPos > scrollThreshold) {
        mainMenu.classList.add("hidden");
      } else {
        mainMenu.classList.remove("hidden");
      }
    }

    if (searchPageHader) {
      if (currentScrollPos > searchScrollThreshold) {
        searchPageHader?.classList.add("search-page__header--invisible");
      } else {
        searchPageHader.classList.remove("search-page__header--invisible");
      }
    }
  };

  toggleMenu();
  window.addEventListener("scroll", toggleMenu, {passive: true});

  // hamburger & dropdown menu
  const menuButton = document.querySelector("[data-hamburger-button]");
  const menuCloseButton = document.querySelector("[data-hamburger-close-button]");
  const menuOverlay = document.querySelector("[data-hamburger-overlay]");
  const menuDrawer = document.querySelector("[data-hamburger-wrapper]");
  const menuContainer = document.querySelector(
    "[data-hamburger-list-container]"
  );
  const dropdownItems = document.querySelectorAll("[data-drop-down]");
  const allLinks = menuContainer && menuContainer.querySelectorAll("a");
  const storeSwitchers = document.querySelectorAll('[data-store-switcher]');

  storeSwitchers.forEach(storeSwitcher => {
    storeSwitcher.addEventListener('click', (event) => {
      event.stopPropagation();
      event.currentTarget.classList.toggle('open');
      document.body.classList.toggle('no-scroll');
    });
  })

  const handleMenuEscKey = (e) => e.key === "Escape" && closeMenu();

  const openMenu = () => {
    const headerBottom = document.querySelector("[data-site-header-container]").getBoundingClientRect().bottom;
    const headerAdjustment = window.innerWidth < 1024 ? `${headerBottom - 5}px` : `0px`;

    menuDrawer.style.top = headerAdjustment;
    document.body.classList.add('no-scroll'); // Disable scrolling to body
    document.body.classList.add('hamburger-active');
    menuDrawer.classList.add("open");
    menuOverlay.classList.add("active");
    document.addEventListener("keyup", handleMenuEscKey);
  };

  const closeMenu = (e) => {
    if (
      e === undefined ||
      (!menuDrawer.contains(e.target) && !menuContainer.contains(e.target))
    ) {
      document.body.classList.remove('hamburger-active');
      document.body.classList.remove('no-scroll'); // Re-enable scrolling to body
      menuDrawer.classList.remove("open");
      menuOverlay.classList.remove("active");
      document.removeEventListener("keyup", handleMenuEscKey);
    }
  };

  function closeMenuBeforeNavigation() {
    menuDrawer.classList.remove("open");
    menuOverlay.classList.remove("active");
  }

  function toggleDropdown(e) {
    const clickedElement = e.target.lastElementChild;

    if (clickedElement instanceof HTMLDivElement) {
       clickedElement.firstElementChild.classList.toggle("open");
    }

    const childList = e.target.nextElementSibling;
    childList.classList.toggle("open");
  }

  menuButton && menuButton.addEventListener("click", openMenu);
  menuOverlay && menuOverlay.addEventListener("click", closeMenu);
  menuCloseButton && menuCloseButton.addEventListener("click", closeMenu);

  if (allLinks) {
    for (const link of allLinks) {
      link.addEventListener("click", closeMenuBeforeNavigation);
    }
  }

  if (dropdownItems) {
    for (const item of dropdownItems) {
      item.addEventListener("click", toggleDropdown);
    }
  }

  // Login form for raffle page

  const raffleLogInForm = document.querySelector('#shopify-section-article-raffle-template #customer_login');
  const recoverPasswordForm = document.querySelector('#raffle__RecoverPasswordForm');
  const forgotPasswordButton = document.querySelector('#raffle__RecoverPassword');
  const cancelPasswordResetButtons = document.querySelectorAll('#shopify-section-article-raffle-template .HideRecoverPasswordLink');

  const showResetPasswordForm = () => {
    raffleLogInForm.classList.add('hide');
    recoverPasswordForm.classList.remove('hide');
  }

  const hideResetPasswordForm = () => {
    raffleLogInForm.classList.remove('hide');
    recoverPasswordForm.classList.add('hide');
  }

  forgotPasswordButton && forgotPasswordButton.addEventListener('click', e => {
    e.preventDefault();
    showResetPasswordForm();
  })

  cancelPasswordResetButtons.forEach(button =>
    button.addEventListener('click', e => {
      e.preventDefault();
      raffleLogInForm.classList.remove('hide');
      hideResetPasswordForm();
    })
  )

  const raffleResetPasswordSuccess = document.querySelector('.reset-password-success');
  const showResetPasswordSuccess = () => {
    showResetPasswordForm();
    raffleResetPasswordSuccess.classList.remove('hide');
  }
  raffleResetPasswordSuccess && showResetPasswordSuccess();
});

// blog clipboard button
const blogClipboardButton = document.querySelector(".blog-others__sharing-link--copy")
if (blogClipboardButton) {
  const clipboardText = blogClipboardButton.dataset.articleUrl
  const blogClipboardButtonText = blogClipboardButton.querySelector("p")
  blogClipboardButton.addEventListener('click', () => {
    navigator.clipboard.writeText(clipboardText).then(function () {
      /* clipboard successfully set */
      blogClipboardButtonText.innerText = "Copied!"
      blogClipboardButtonText.style.fontWeight = "bold"
      setTimeout(() => {
        blogClipboardButtonText.innerText = "Copy"
        blogClipboardButtonText.style.fontWeight = "normal"
      }, 2500)
    }, function () {
      /* clipboard write failed */
      console.log("Failed to copy to clipboard")
    });
  })
}


// generate irregular grid home page
const homePageProducts = document.querySelectorAll(
  ".infinite-scroll__item.product"
);
const homePageBlogs = document.querySelectorAll(".infinite-scroll__item.blog");
const overviewBlogs = document.querySelectorAll(
  ".infinite-scroll__item.blog-small"
);

if (window.screen.width >= 750) {
  for (const [i, homePageProduct] of homePageProducts.entries()) {
    let isFifthIteration = (i + 1) % 5 === 0;

    if (isFifthIteration) {
      homePageProduct.classList.add("s2");
    } else {
      homePageProduct.classList.add("s1");
    }

    if (homePageProduct.classList.contains("s2")) {
      homePageProduct.querySelector("h3").classList.add("h3");
      homePageProduct.padding = `${getRandomSize(8, 16)}px`;
    } else {
      homePageProduct.querySelector("h3").classList.add("h3-patta-custom");
    }
  }

  for (const homePageBlog of homePageBlogs) {
    homePageBlog.classList.add(`s${getRandomSize(1, 2)}`);
    if (homePageBlog.classList.contains("s1")) {
      homePageBlog.querySelector("h3").classList.add("h3-patta-custom");
    } else {
      homePageBlog.querySelector("h3").classList.add("h3");
    }
  }

  for (const overviewBlog of overviewBlogs) {
    overviewBlog.classList.add(`s${getRandomSize(1, 2)}`);
    overviewBlog.padding = `${getRandomSize(4, 8)}px`;
    if (overviewBlog.classList.contains("s1")) {
      overviewBlog.querySelector("h3").classList.add("h3-patta-custom");
    } else {
      overviewBlog.querySelector("h3").classList.add("h3");
    }
  }
}

function fadeInPage() {
  if (!window.AnimationEvent) {
    return;
  }
  const layer = document.getElementById("transitionLayer");
  layer.classList.add("fade-out");
}

window.addEventListener("pageshow", function (event) {
  if (!event.persisted) {
    return;
  }
  const layer = document.getElementById("transitionLayer");
  layer.classList.remove("fade-in");
});


// Helper function to remove UFOC (unstyled flash of content)
const domReady = (callback) => {
  document.readyState === 'interactive' || document.readyState === 'complete'
    ? callback()
    : document.addEventListener('DOMContentLoaded', callback);
};

domReady(() => {
  // Display body when DOM is loaded
  document.body.style.visibility = 'visible';
})

const languageElem = document.querySelectorAll('[data-languages]')

const getLang = iso => {
  return window.Phill.languages[iso]
}

const getPathName = (current, target) => {
  let targetPath = target !== '/' ? target : ''
  let currentPath = current !== '/' ? current : ''
  return window.location.pathname.replace(currentPath, targetPath)
}

const getPreferredLang = () => {
  const browserLang = navigator.languages.find(l => getLang(l)) || 'en'
  const lang = localStorage.getItem('pref_lang') || browserLang
  return {
    root: getLang(lang),
    lang: lang
  }
}

const changeLanguage = (current, target) => {
  localStorage.setItem('pref_lang', target)
  window.location.pathname = getPathName(current, getLang(target))
}

const languageSelector = node => {
  const list = node.querySelector('[data-list]')
  const items = node.querySelectorAll('[data-item]')
  const select = node.querySelector('[data-select]')
  const preferred = getPreferredLang()

  let value = select.value
  let currentLanguage = getLang(value)

  if(preferred.root !== currentLanguage) changeLanguage(currentLanguage, preferred.lang)

  node.addEventListener('click', () => {
    list.classList.toggle('open')
  })

  items.forEach(item => {
    item.addEventListener('click', () => {
      value = item.dataset.value
      select.value = value
      changeLanguage(currentLanguage, value)
    })
  })
}

languageElem.forEach(languageSelector)

const syncHeight = () => {
  document.documentElement.style.setProperty(
    "--window-inner-height",
    `${window.innerHeight}px`
  );
}

window.addEventListener("resize", syncHeight);

let scrollY; // we'll store the scroll position here

function preventDefault(e) {
  e.preventDefault();
}

function lockBody(modal, lockDelay) {
  if (window.innerWidth < 1024) {
    // remember scroll position
    scrollY = window.scrollY;
    if (modal) {
      modal.addEventListener("pointermove", preventDefault);
    }
    if (lockDelay) {
      // no-scroll-mobile will scroll page to top, so we delay it if the modal doesn't cover the full screen right away (i.e. cart drawer slide in animation)
      setTimeout(() => {
        document.documentElement.classList.add("no-scroll-mobile");
      }, 500)
    } else {
      document.documentElement.classList.add("no-scroll-mobile");
    }
  } else {
    document.body.classList.add("no-scroll");
  }
}

function unlockBody(modal) {
  if (window.innerWidth < 1024) {
    document.documentElement.classList.remove("no-scroll-mobile");
    if (modal) {
      modal.removeEventListener("pointermove", preventDefault);
    }
    // restore scroll position
    window.scrollTo(0, scrollY);
  } else {
    document.body.classList.remove("no-scroll");
  }
}